import { getTokens } from '../actions/tokens';
import {
    WAITLIST_ARGUMENT_ERROR_MESSAGE,
    WAITLIST_DEFAULT_ERROR_MESSAGE,
    WAITLIST_FULL_ERROR_MESSAGE,
} from '../constants';
import { fetchV3WithTranslateServerErrors, getOrderFlowHeaders } from './base';
import { getAddToWaitlistUrl } from './constants';

const WAITLIST_ERROR_SPEC = {
    default: () => WAITLIST_DEFAULT_ERROR_MESSAGE,
    ARGUMENTS_ERROR: () => WAITLIST_ARGUMENT_ERROR_MESSAGE,
    WAITLIST_FULL: () => WAITLIST_FULL_ERROR_MESSAGE,
};

export const addToWaitlist = (
    eventId: string,
    buyerData: {
        firstName: string;
        lastName: string;
        email: string;
        phone?: string;
    },
) => {
    const addToWaitlistEndpoint = getAddToWaitlistUrl(eventId);
    const { firstName, lastName, email, phone } = buyerData;

    const tokens = getTokens();
    const headers = getOrderFlowHeaders(tokens);

    return fetchV3WithTranslateServerErrors(
        WAITLIST_ERROR_SPEC,
        addToWaitlistEndpoint,
        {
            method: 'POST',
            headers,
            body: JSON.stringify({
                first_name: firstName,
                last_name: lastName,
                email,
                home_phone: phone,
            }),
        },
    );
};
